import publicFormluar from "./public/formular"
import publicToken from "./public/token"
import privateFormular from "./private/formular"
import privateToken from "./private/token"

export default {
  publicFormluar,
  privateFormular,
  publicToken,
  privateToken
}
